import { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import JobFilterContext from "../../contexts/JobFilterContext";
import { fetchJobs } from "../../features/jobs/jobsSlice";
import { removeComa } from "../../utils/common";
import JobItem from "./JobItem";

export default function JobList () {
    const dispatch = useDispatch();
    const {jobs, isLoading, isError, errorMessage} = useSelector(state => state.jobs);

    const { jobFilter: jobType } = useContext(JobFilterContext) || {};
    const { searchText, sort } = useSelector(state => state.filter);

    useEffect(() => {
        dispatch(fetchJobs());
    }, [dispatch]);

    let content = null;
    if (isLoading) {
        content = <p>Loading...</p>;
    }
    else if (!isLoading && isError) {
        content = <p className="error">{errorMessage}</p>;
    }
    else if (!isLoading && !isError && jobs?.length > 0) {
        let filteredJobs = jobs.map(j => ({...j}));
        // Apply job type filter
        if (Boolean(jobType) && jobType !== '') {
            filteredJobs = jobs.filter(j => j.type === jobType);
        }

        // Apply search
        if (searchText !== '') {
            filteredJobs = filteredJobs.filter(j => j.title.toLowerCase().includes(searchText.toLowerCase()));
        }

        // Apply order
        if (sort === 'Salary_ASC') {
            filteredJobs.sort((a, b) => Number(removeComa(a.salary)) - Number(removeComa(b.salary)));
        }
        else if (sort === 'Salary_DESC') {
            filteredJobs.sort((a, b) => Number(removeComa(b.salary)) - Number(removeComa(a.salary)));
        }

        content = filteredJobs.map((job) => <JobItem key={job.id} job={job} /> );
    }
    else if (!isLoading && !isError && jobs?.length === 0) {
        content = <p>No jobs available!</p>;
    }

    return (
        <div className="jobs-list ">
            {content}
        </div>
    );
}